import { alpha, Box, Grid2, Typography } from "@mui/material";
import ReceiveIcon from "assets/svg/ReceiveIcon";
import TransactionStatsIcon from "assets/svg/TransactionStatsIcon";
import TransferIcon from "assets/svg/TransferIcon";
import UsersIcon from "assets/svg/UsersIcon";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ADMIN_DASHBOARD_STATS,
  FETCH_ADMIN_PROFILE,
} from "reduxStore/actions/authActionType";
import { RootState } from "reduxStore/store";
import theme, { responsiveFontSize } from "themes/Theme";
import { formatNumber } from "utils/formatter";
import EarningGraph from "./components/EarningGraph";
import TransactionRatio from "./components/TransactionRatio";

const DashboardPage = () => {
  const dispatch = useDispatch();
  const { adminDashboardStats, loading } = useSelector(
    (state: RootState) => state.adminDashboardStats
  );

  useEffect(() => {
    dispatch({ type: FETCH_ADMIN_DASHBOARD_STATS, payload: {} });
    dispatch({ type: FETCH_ADMIN_PROFILE });
  }, []);

  return (
    <Box sx={styles.container}>
      <Grid2 container spacing={2} mb={2}>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <Box sx={styles.statsCardContainer}>
            <UsersIcon />
            <Box>
              <Typography sx={styles.statsLabelText}>Total Users</Typography>
              <Typography sx={styles.statsValueText}>
                {adminDashboardStats?.data?.totalUsers
                  ? formatNumber(adminDashboardStats?.data?.totalUsers)
                  : "0"}
              </Typography>
              <Typography sx={styles.statsCardSubtitle}>
                for this year
              </Typography>
            </Box>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <Box sx={styles.statsCardContainer}>
            <TransferIcon />
            <Box>
              <Typography sx={styles.statsLabelText}>Total Transfer</Typography>
              <Typography sx={styles.statsValueText}>
                {adminDashboardStats?.data?.totalTransferCount
                  ? formatNumber(adminDashboardStats?.data?.totalTransferCount)
                  : "0"}
              </Typography>
              <Typography sx={styles.statsCardSubtitle}>
                for this year
              </Typography>
            </Box>
          </Box>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 3 }}>
          <Box sx={styles.statsCardContainer}>
            <ReceiveIcon />
            <Box>
              <Typography sx={styles.statsLabelText}>Total Received</Typography>
              <Typography sx={styles.statsValueText}>
                {adminDashboardStats?.data?.totalReceiveCount
                  ? formatNumber(adminDashboardStats?.data?.totalReceiveCount)
                  : "0"}
              </Typography>
              <Typography sx={styles.statsCardSubtitle}>
                for this year
              </Typography>
            </Box>
          </Box>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 3 }}>
          <Box sx={styles.statsCardContainer}>
            <TransactionStatsIcon />
            <Box>
              <Typography sx={styles.statsLabelText}>
                Total Transactions
              </Typography>
              <Typography sx={styles.statsValueText}>
                {adminDashboardStats?.data?.totalTransactionsCount
                  ? formatNumber(
                      adminDashboardStats?.data?.totalTransactionsCount
                    )
                  : "0"}
              </Typography>
              <Typography sx={styles.statsCardSubtitle}>
                for this year
              </Typography>
            </Box>
          </Box>
        </Grid2>
      </Grid2>

      <Grid2 container spacing={2} mb={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <EarningGraph />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <TransactionRatio />
        </Grid2>
      </Grid2>
    </Box>
  );
};
export default DashboardPage;
const styles = {
  container: {
    flexGrow: 1,
    ml: { xs: 0, md: -5 },
  },
  statsCardContainer: {
    py: 2,
    px: 1,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
    borderRadius: 3,
    boxShadow: `rgba(8, 60, 61, 0.27) 0px 1px 5px 0px, rgba(8, 60, 61, 0.06) 0px 1px 5px 0px`,
    backgroundColor: "rgb(255, 255, 255)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  statsLabelText: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.primary.main,
    lineHeight: 1.2,
  },
  statsValueText: {
    fontSize: responsiveFontSize(35),
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  statsCardSubtitle: {
    fontSize: responsiveFontSize(12),
    fontWeight: 300,
    color: theme.palette.text.secondary,
    lineHeight: 1.2,
    mt: 0.5,
    ml: 0.5,
  },
};
